import { ComponentType, FC, lazy } from 'react';
import { wrapInSuspense } from '../../helpers/reactHelpers';
import { JsonSchemaFormProps } from './JsonSchemaFormTypes';

const JsonSchemaFormElement = lazy(() => import('./JsonSchemaFormElement')) as ComponentType<JsonSchemaFormProps>;

const JsonSchemaForm: FC<JsonSchemaFormProps> = (props) => {
    return wrapInSuspense(<JsonSchemaFormElement  {...props} />);
};

export default JsonSchemaForm;